import { render, staticRenderFns } from "./TotalTested.vue?vue&type=template&id=3d0c2ec5"
import script from "./TotalTested.vue?vue&type=script&lang=js"
export * from "./TotalTested.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports